module.exports = __webpack_public_path__ + "img/AGR-i-2-I.99423b7b.png";